<wc-wrapper [contentWrapper]="wrapper">
  <sd-table sd-component-wrapper-component
    (linkClicked)="onLinkClick($event)"
    [columns]="columns"
    [entries]="entries"
    [verticalLayout]="true"
    [maxLine]="maxLine"
    [maxColumn]="maxColumn"
    [showSize]="showSize"
    [titleLevel]="titleLevel"
    [title]="title"
  />
</wc-wrapper>
